import React from "react";

import { HeaderTemplate } from "../../templates/HeaderTemplate/HeaderTemplate";

import Menu from "./HeaderMenu";

import "./Header.scss";

const Header = ({ isHiddenMenu }) => (
    <HeaderTemplate center={!isHiddenMenu && <Menu />}/>
);

export default Header;
